module.exports = __webpack_public_path__ + "img/评论1_03.984ee0cb.jpg";